import React, { useState, useEffect } from 'react'
import { useParams } from "react-router-dom";
import "./css/ProductDetail.css";
import { firestore } from "../firebase";
import { Avatar } from '@mui/material';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function ProductDetail() {
  const { title } = useParams();
  const history = useHistory();
  const [productData, setProductData] = useState([]);

  useEffect(() => {
    const productInfoRef = firestore.collection("products").doc(title);
    productInfoRef
    .get()
    .then((doc) => {
      const data = doc.data();
      setProductData(data);
      console.log("Product Details")
    })
    .catch(error => console.log(error.message));
  },[title])

  const deleteItem = (e) => {
    const shouldDelete = window.confirm('Are you sure you want to delete this item?');
    if (shouldDelete) {
      const deleteRef = firestore.collection("products").doc(title);
      deleteRef
        .delete()
        .then(() => {
          alert(`${title} is deleted`);
          history.push('/products');
        })
        .catch((error) => {
          console.error('Error deleting item:', error);
        });
    } else {
      alert('Deletion canceled');
    }
  };

  const productImages = productData?.productImage && [
    productData?.productImage?.[0],
    productData?.productImage?.[1],
    productData?.productImage?.[2],
    productData?.productImage?.[3],
    productData?.productImage?.[4],
  ];

  const [imageSlide, setImageSlide] = useState("");

  useEffect(() => {
    setImageSlide(productImages?.productImage?.[0]);
  }, []);

  const changeImage = (newImage) => {
    setImageSlide(newImage);
  };

  return (
    <div className="product-details">
      <div className='product-infos'>
        <div className='product-picks'>
        <div className='product-images'>
          <img src={imageSlide || productData?.productImage?.[0]} alt={productData?.productName} />
        </div>
        <div className='other-images'>
          {productImages?.map((image, index) => (
            <Avatar onClick={() => changeImage(image)} src={image} key={index}/>
          ))}
          </div>
        </div>
        <div className='product-des'>
          <h1> {productData?.productName} </h1>
          <h3> ${productData?.productPrice} </h3>
          <p><span style={{fontWeight: "bold"}}>Product Category:</span> {productData?.productCategory}</p>
          <p><span style={{fontWeight: "bold"}}>Delivery:</span> {productData?.productDelivery} </p>
          <p><span style={{fontWeight: "bold"}}>Product Description:</span> {productData?.productDesc}</p>
          <button style={{marginLeft: "10px"}} onClick={deleteItem}>Delete</button>
        </div>
      </div>
      <br />
    </div>
  )
}

export default ProductDetail